<div class="row">
  <div class="col-md-8">
    <div class="card">
      <div class="card-header card-header-icon card-header-rose">
        <div class="card-icon">
          <i class="material-icons"></i>
        </div>
        <h4 class="card-title">Add new client</h4>
      </div>
      <div class="card-body">
        <div mat-dialog-content>
          <form
            name="userNewForm"
            #userNewForm="ngForm"
            (ngSubmit)="onSubmit()"
          >
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <app-filter
                    type="COMPANY"
                    (select)="changeCompany($event)"
                  ></app-filter>

                  <button
                    (click)="openNuevoCompany()"
                    mat-raised-button
                    class="btn btn-success"
                  >
                    <span class="btn-label">
                      <i class="material-icons">note_add</i>
                    </span>
                    New Company
                  </button>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="bmd-label-floating">Title</label>
                  <input
                    type="text"
                    class="form-control"
                    name="ocupation"
                    #ocupation="ngModel"
                    [(ngModel)]="data.user.ocupation"
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="bmd-label-floating">First Name</label>
                  <input
                    type="text"
                    class="form-control"
                    name="name"
                    #name="ngModel"
                    [(ngModel)]="data.user.name"
                    required
                  />
                  <span *ngIf="!name.valid && name.touched">
                    ¡Name not valid!
                  </span>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label class="bmd-label-floating">Last Name</label>
                  <input
                    type="text"
                    class="form-control"
                    name="surname"
                    #surname="ngModel"
                    [(ngModel)]="data.user.surname"
                    required
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="bmd-label-floating">email</label>
                  <input
                    type="email"
                    class="form-control"
                    name="email"
                    #email="ngModel"
                    [(ngModel)]="data.user.email"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="bmd-label-floating">Gender</label>
                  <select
                    name="gender"
                    #gender="ngModel"
                    [(ngModel)]="data.user.gender"
                    placeholder="Gender"
                    class="form-control"
                    required
                  >
                    <option value="" disabled>Please select a gender</option>
                    <option *ngFor="let sexo of sexos" [value]="sexo.value">
                      {{ sexo.viewValue }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row">
              <h4
                class="card-title"
                style="margin-left: 20px; margin-top: 40px"
              >
                Address information
              </h4>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="bmd-label-floating">Addresss </label>
                  <select
                    name="userlocation"
                    #userlocation="ngModel"
                    [(ngModel)]="data.user.locationId"
                    (change)="changeLocation()"
                    class="form-control fctrl"
                  >
                    <option [value]="null">Headquarter's Address</option>
                    <option
                      *ngFor="let loc of companyLocations"
                      [value]="loc.id"
                    >
                      {{ loc.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="bmd-label-floating">Address Line #</label>
                  <input
                    type="text"
                    class="form-control"
                    name="address"
                    #address="ngModel"
                    [(ngModel)]="data.user.address"
                    readonly
                  />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label class="bmd-label-floating">Address Line 2 #</label>
                  <input
                    type="text"
                    class="form-control"
                    name="address2"
                    #address2="ngModel"
                    [(ngModel)]="data.user.address2"
                    readonly
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label class="bmd-label-floating">City</label>
                  <input
                    type="text"
                    class="form-control"
                    name="city"
                    #city="ngModel"
                    [(ngModel)]="data.user.city"
                    readonly
                  />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label class="bmd-label-floating">State</label>
                  <input
                    type="text"
                    class="form-control"
                    name="colonia"
                    #colonia="ngModel"
                    [(ngModel)]="data.user.colonia"
                    readonly
                  />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label class="bmd-label-floating">Country</label>
                  <input
                    type="text"
                    class="form-control"
                    name="country"
                    #country="ngModel"
                    [(ngModel)]="data.user.country"
                    readonly
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2">
                <div class="form-group">
                  <label class="bmd-label-floating">Zip Code</label>
                  <input
                    type="text"
                    class="form-control"
                    name="zipCode"
                    #zipCode="ngModel"
                    [(ngModel)]="data.user.zipCode"
                    readonly
                  />
                </div>
              </div>

              <div class="col-md-5">
                <div class="form-group">
                  <label class="bmd-label-floating">Work Phone</label>
                  <input
                    type="text"
                    class="form-control"
                    name="phone"
                    #phone="ngModel"
                    [(ngModel)]="data.user.phone"
                  />
                </div>
              </div>

              <div class="col-md-5">
                <div class="form-group">
                  <label class="bmd-label-floating">Mobile Phone</label>
                  <input
                    type="text"
                    class="form-control"
                    name="mobilePhone"
                    #mobilePhone="ngModel"
                    [(ngModel)]="data.user.mobilePhone"
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <h4
                class="card-title"
                style="margin-left: 20px; margin-top: 40px"
              >
                Settings
              </h4>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="bmd-label-floating">Email Frequency</label>
                  <select
                    id="companyform"
                    name="frequency"
                    #frequency="ngModel"
                    [(ngModel)]="data.user.emailFrequency"
                    placeholder="Email Frequenc"
                    class="form-control"
                    required
                  >
                    <option value="" disabled>* Please select a company</option>
                    <option
                      *ngFor="let frequency of frequencies"
                      [value]="frequency.value"
                    >
                      {{ frequency.viewValue }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div class="col-md-4">
    <div class="card">
      <div class="card-header card-header-icon card-header-rose">
        <div class="card-icon">
          <i class="material-icons"></i>
        </div>
        <h4 class="card-title">Password</h4>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="bmd-label-floating">Password</label>
              <input
                type="text"
                name="password"
                #password="ngModel"
                [(ngModel)]="data.user.password"
                required
                class="form-control"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <button
    mat-button
    [disabled]="data.user.password == '' || data.user.email == ''"
    class="btn btn-success"
    [mat-dialog-close]="data.user"
    cdkFocusInitial
  >
    Save
  </button>
</div>
